export const primaryLight = (theme: any) => {
  return theme.palette.primary.light;
};

export const primaryMain = (theme: any) => {
  return theme.palette.primary.main;
};
///
///
export const primaryDark = (theme: any) => {
  return theme.palette.primary.dark;
};

export const secondaryLight = (theme: any) => {
  return theme.palette.secondary.light;
};

export const secondaryMain = (theme: any) => {
  return theme.palette.secondary.main;
};

export const secondaryDark = (theme: any) => {
  return theme.palette.secondary.dark;
};

export const commonWhite = (theme: any) => {
  return theme.palette.common.white;
};

export const commonBlack = (theme: any) => {
  return theme.palette.common.black;
};

export const greyVariations = (theme: any, variant: number) => {
  return theme.palette.grey[variant];
};
